export class UserLoginModel {
  public email: string;
  public password: string;
}



// WEBPACK FOOTER //
// ./src/app/models/user/user-login.model.ts